const componentSocialBar	= require('../../components/component-socialbar/component-socialbar.config');
module.exports = {
	componentSocialBar: 	componentSocialBar.context
};